module.exports = __webpack_public_path__ + "static/media/gov-agency-resource.fbfd2a49.png";